import React from "react";

const ScreenshotDisplay = () => {
  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px"
    }}>
      <img 
        src="https://s3.amazonaws.com/social-images-public/main/join-form-phone-entry.png"
        alt="Join Form Phone Entry Screenshot"
        style={{
          maxWidth: "100%",
          maxHeight: "90vh",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px"
        }}
      />
    </div>
  );
};

export default ScreenshotDisplay;